import { z } from "zod";
import { gaPushEvent } from "../base.analytics";

enum InviteAnalyticsEvent {
  ROOM_JOIN = "room_join",
}

export const roomDiscoveryChannelSchema = z.enum([
  "public app",
  "shared article",
  "qr code",
  "related room",
  // The feed's recommended-room card. Before this existed, a join from that
  // card was stamped "public app" — indistinguishable from any other join —
  // so the channel the PRD's comparator is built on had no numerator either.
  "feed card",
  // The agent proposed the room mid-conversation (docs/juisci-gpt-room-suggestion.md).
  // This is what makes a GPT-driven join attributable in `room_joined` — without
  // it the tap lands on the room page with no state and counts as "public app".
  "juiscigpt",
]);

export type RoomDiscoveryChannel = z.infer<typeof roomDiscoveryChannelSchema>;

export function gaEventRoomJoin(payload: {
  roomUid: string;
  userUid?: string;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmContent?: string | null;
  origin?: string;
  roomType?: "public" | "private";
  roomName?: string;
  roomCount?: number | null;
  roomDiscoveryChannel?: RoomDiscoveryChannel;
}) {
  gaPushEvent(InviteAnalyticsEvent.ROOM_JOIN, {
    room_id: payload.roomUid,
    account_id: payload.userUid,
    origin: payload.origin,
    room_name: payload.roomName,
    room_discovery_channel: payload.roomDiscoveryChannel,
    room_type: payload.roomType,
    room_count: payload.roomCount,
    ...(payload.utmSource ? { utm_source: payload.utmSource } : {}),
    ...(payload.utmMedium ? { utm_medium: payload.utmMedium } : {}),
  });
}
